import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Brand } from "./Logo";
import { OFFICE } from "../../lib/content";

export const Footer = () => (
  <footer className="bg-[#0A1F44] border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <Brand light />
        <p className="mt-6 text-slate-300 text-sm leading-relaxed max-w-sm">
          Australian-owned. Sydney-based. For over 10 years we have supported organisations across
          retail, government, not-for-profit, utilities, banking & insurance and education with
          specialist ICT recruitment.
        </p>
        <p className="mt-6 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-slate-400">
          BMP Tech One Pty Ltd
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400 mb-5">Navigate</p>
        <ul className="space-y-3 text-sm">
          {[
            ["Services", "/services"],
            ["Approach", "/approach"],
            ["Experience", "/experience"],
            ["Process", "/process"],
            ["Discuss a role", "/contact"],
          ].map(([label, to]) => (
            <li key={to}>
              <Link
                to={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-slate-400 hover:text-amber-300 transition-colors duration-200"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400 mb-5">Sydney HQ</p>
        <address className="not-italic text-sm text-slate-400 space-y-1.5">
          {OFFICE.address.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </address>
        <div className="mt-5 space-y-1.5 text-sm">
          <p>
            <a href={`mailto:${OFFICE.email}`} data-testid="footer-email" className="text-slate-300 hover:text-amber-300 transition-colors duration-200">
              {OFFICE.email}
            </a>
          </p>
          <p className="text-slate-400">AU {OFFICE.phoneAU}</p>
          <p className="text-slate-400">NZ {OFFICE.phoneNZ}</p>
        </div>
        <a
          href={OFFICE.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-map-link"
          className="mt-5 inline-flex items-center gap-1.5 text-sm text-amber-300 hover:text-amber-200 transition-colors duration-200"
        >
          View office location <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>

    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row gap-3 justify-between">
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-slate-400">
          © {new Date().getFullYear()} BMP Tech One Pty Ltd · bmptechone.com.au
        </p>
        <p className="font-mono text-[0.65rem] uppercase tracking-[0.18em] text-slate-400">
          Your recruitment partner
        </p>
      </div>
    </div>
  </footer>
);
